exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SoundGroupExercise-module__wrapper___XdzHH{display:grid;gap:.5rem}.SoundGroupExercise-module__wrapper___XdzHH .SoundGroupExercise-module__history-row___1yXLe.SoundGroupExercise-module__active___3hFWV *{cursor:pointer}", ""]);

// exports
exports.locals = {
	"wrapper": "SoundGroupExercise-module__wrapper___XdzHH",
	"history-row": "SoundGroupExercise-module__history-row___1yXLe",
	"active": "SoundGroupExercise-module__active___3hFWV"
};